import { TabItem, Toggle } from "@atoms"

import { Popover, TabStack } from "@molecules"

import { BottomSheetItemBase } from "@organisms/BottomSheet/BottomSheetItem/BottomSheetItem"
import ComponentNavigation from "@organisms/ComponentNavigation/ComponentNavigation"

import useJobTimelineViewEventHandlers from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewEventHandlers"
import useJobTimelineViewStates from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewStates"

import styles from "./TimelineViewMenuBottomSheet.module.scss"

export default function TimelineViewMenuBottomSheet() {
    const {
        jobCardStyle,
        setJobCardStyleToCompact,
        setJobCardStyleToRegular,
        shouldShowCancelledJobs,
        shouldShowFinalizedJobs,
        timelineViewOrientation,
        shouldShowWeekends,
    } = useJobTimelineViewStates()

    const {
        onCancelledJobsToggle,
        onFinalizedJobsToggle,
        onSetSchedulerToHorizontal,
        onSetSchedulerToVertical,
        onShowWeekendsToggle,
    } = useJobTimelineViewEventHandlers()

    return (
        <Popover.Section animationType="slide">
            <div className={styles.content}>
                <BottomSheetItemBase isTabbable={true} label="Show Finalized Jobs" onClick={onFinalizedJobsToggle}>
                    <Toggle checked={shouldShowFinalizedJobs} isControlled={false} />
                </BottomSheetItemBase>
                <BottomSheetItemBase isTabbable={true} label="Show Cancelled Jobs" onClick={onCancelledJobsToggle}>
                    <Toggle checked={shouldShowCancelledJobs} isControlled={false} />
                </BottomSheetItemBase>
                <BottomSheetItemBase label="Show Weekends" onClick={onShowWeekendsToggle}>
                    <Toggle checked={shouldShowWeekends} isControlled={false} />
                </BottomSheetItemBase>
                <BottomSheetItemBase isTabbable={true} label="Timeline Orientation">
                    <TabStack variant="contained" size="md">
                        <TabItem
                            isSelected={timelineViewOrientation === "vertical"}
                            onClick={onSetSchedulerToVertical}
                            noDebounce={true}
                        >
                            Vertical
                        </TabItem>
                        <TabItem
                            isSelected={timelineViewOrientation === "horizontal"}
                            onClick={onSetSchedulerToHorizontal}
                            noDebounce={true}
                        >
                            Horizontal
                        </TabItem>
                    </TabStack>
                </BottomSheetItemBase>
                {timelineViewOrientation === "horizontal" && (
                    <BottomSheetItemBase isTabbable={true} label="Job Card Style">
                        <TabStack variant="contained" size="md">
                            <TabItem
                                isSelected={jobCardStyle === "compact"}
                                onClick={setJobCardStyleToCompact}
                                noDebounce={true}
                            >
                                Compact
                            </TabItem>
                            <TabItem
                                isSelected={jobCardStyle === "regular"}
                                onClick={setJobCardStyleToRegular}
                                noDebounce={true}
                            >
                                Regular
                            </TabItem>
                        </TabStack>
                    </BottomSheetItemBase>
                )}
                <ComponentNavigation.Navigate to="time-frame" asChild={true} direction="right">
                    <BottomSheetItemBase isTabbable={true} label="Time Frame" hasSubItems={true} />
                </ComponentNavigation.Navigate>
            </div>
        </Popover.Section>
    )
}
